export default __webpack_public_path__ + "static/23-222356bfb38215e8952119afe3261e7a.png";